import AiUsageComponent from '../AiUsageComponent.vue'

export default [
    {
        // Admins only (Super Admin, Admin): AiCostController checks config mcp.roles.admin.
        path: '/ai-usage',
        name: 'AI Usage',
        meta: { layout: 'mystagit' },
        component: AiUsageComponent,
    },
]
